@if (held(); as current) {
  <div
    class="held-stitch-tray"
    data-stitch-carry
    role="group"
    aria-label="Item held for stitching"
    appDraggable
    [appDraggableData]="current.dragData"
    [appDraggableContextId]="current.contextId"
    [appDraggablePlaceholder]="ghost"
    [appDraggableNoShadow]="true"
  >
    <span class="held-stitch-tray-label">Drag to stitch: {{ current.item.title }}</span>
    <button type="button" class="held-stitch-tray-close" aria-label="Discard held item" (click)="discard()">×</button>
  </div>
  <ng-template #ghost>
    <div class="held-stitch-tray held-stitch-tray-ghost">
      <span class="held-stitch-tray-label">Drag to stitch: {{ current.item.title }}</span>
      <span class="held-stitch-tray-close">×</span>
    </div>
  </ng-template>
}
